import { Component, OnInit } from '@angular/core';
import { RIGHT_COLUMN_DATA_REFORMA } from '@constants/informe-pensiones.constants';
import { ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { IRightColumnData } from '@shared/common/interfaces/right-column-data.interface';
import { IPropiedadesVideoIPPResponse, IValidateVideoIPPResponse } from '@shared/common/interfaces/video-ipp.interface';
import { Util } from '@shared/common/utils/util';
import { InformePensionesService } from '../../services/informe-pensiones.service';

@Component({
  selector: 'app-informe-pensiones-home',
  templateUrl: './informe-pensiones-home.component.html',
  styleUrl: './informe-pensiones-home.component.scss',
  standalone: false
})
export class InformePensionesHomeComponent implements OnInit, ViewWillEnter, ViewWillLeave {

  showErrorScreen: boolean = false;
  rightColumnData: IRightColumnData[] = [];
  attempt: boolean = false;
  nAttempts: number = 1;
  private lanzaEncuesta: boolean = false;
  isValidateVideoIPP: boolean = false;
  loadingVideoIPP: boolean = false;
  propiedadesVideo: IPropiedadesVideoIPPResponse | null = null;

  constructor(private readonly _informePensionesService: InformePensionesService,
              private readonly _util: Util
  ){}

  ngOnInit() {
    this.rightColumnData = [RIGHT_COLUMN_DATA_REFORMA[0]];
    void this.getVideoIPP();
  }
  
  async getVideoIPP() {
    try {
      this.loadingVideoIPP = true;
      const token = await this._util.getIdToken();

      if (!token) {
        return;
      }

      const validarVideo: IValidateVideoIPPResponse = await this._informePensionesService.getValidarVideoIPP(token);

      if (validarVideo?.has_video_properties) {
        this.propiedadesVideo = await this._informePensionesService.getPropiedadesVideoIPP(token);
        this.isValidateVideoIPP = true;
        this.loadingVideoIPP = false;
      }else{
        this.isValidateVideoIPP = false;
        this.loadingVideoIPP = false;
      }
    } catch (error) {
      console.error('Error obteniendo video IPP:', error);
      this.isValidateVideoIPP = false;
      this.loadingVideoIPP = false;
    }
  }

  ionViewWillEnter() {
    this.levantarEncuesta();
  }

  ionViewWillLeave() {
    this.lanzaEncuesta = false;
  }

  goBack(): void {
    (globalThis).history.back();
  }

  idRightColumnEmit(event: string) {
    const element = document.getElementById(event);

    setTimeout(() => {

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } else {
        console.warn('Elemento no encontrado:', event);
      }
    }
      , 100);
  }

  private levantarEncuesta() {
    this.lanzaEncuesta = true;
    setTimeout(() => {
      if (this.lanzaEncuesta) {
        localStorage.setItem('encuestaStorage', 'informe-pensiones-personalizado');
        const evento = new StorageEvent('storage', {
          key: 'encuestaStorage',
          oldValue: 'informe-pensiones-personalizado',
          newValue: 'informe-pensiones-personalizado',
          url: globalThis.location.href,
          storageArea: localStorage,
        });
        globalThis.dispatchEvent(evento);
        this.lanzaEncuesta = false;
      }
    }, 10000);
  }
}
